import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ordering_3fccc7c3fe7f4921355fe405c2547cf6",
  "use": "ordering_3fccc7c3fe7f4921355fe405c2547cf6-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ordering_3fccc7c3fe7f4921355fe405c2547cf6\">\n<path d=\"M10.6666 11.34V6.66667H9.33325V11.34H7.33325L9.99992 14L12.6666 11.34H10.6666ZM5.99992 2L3.33325 4.66H5.33325V9.33333H6.66659V4.66H8.66659L5.99992 2ZM10.6666 11.34V6.66667H9.33325V11.34H7.33325L9.99992 14L12.6666 11.34H10.6666ZM5.99992 2L3.33325 4.66H5.33325V9.33333H6.66659V4.66H8.66659L5.99992 2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol